import _ from 'lodash';
import LanguageToLocaleMap from '../mappers/constants/language-id-to-locale.map';
import DefaultBrandMap from '../mappers/constants/default-information.map';
import SupportedLocalesMap from '../mappers/constants/supported-locale.map';

const getLanguageFromLinfoCookie = (expediaCookie) => {
  const cookieArr = expediaCookie ? expediaCookie.split(';') : [];
  const languageCodeCookieIndex = _.findIndex(cookieArr, (cookie) => {
    return cookie && cookie.includes('linfo');
  });
  if (languageCodeCookieIndex !== -1) {
    const languageCodeKeys = Object.keys(LanguageToLocaleMap);
    const indexOfLangCode = _.findIndex(languageCodeKeys, (key) => {
      return cookieArr[languageCodeCookieIndex].includes(`|${key}|`);
    });
    return languageCodeKeys[indexOfLangCode] || DefaultBrandMap.langId;
  }
  return DefaultBrandMap.langId;
};

const getSupportedLocale = (cookie) => {
  const brandLanguage = getLanguageFromLinfoCookie(cookie);
  let locale = brandLanguage
    ? LanguageToLocaleMap[brandLanguage].toLowerCase()
    : DefaultBrandMap.locale;

  locale = SupportedLocalesMap[locale] ? locale : DefaultBrandMap.locale;
  return locale;
};

export { getLanguageFromLinfoCookie, getSupportedLocale };
